import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../../../services/payment.service';
import { finalize } from 'rxjs';
import { SubscriptionInfo } from '../../../common/models/payment/subscription-info';
import { AuthService } from '../../../services/auth/auth.service';
import { UserRole } from '../../../common/models/user/user-role.enum';
import { DialogService } from '../../../services/dialog/dialog.service';
import { LoaderService } from '../../../services/loader.service';
import { PaymentType } from '../../../common/models/payment/payment-type';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '../../../services/toast.service';
import { BasicUserData } from '../../../common/models/user/basic-user-data';
import { SimpleStatus } from '../../../common/models/common/simple-status';

@Component({
  selector: 'psc-subscription',
  templateUrl: './subscription.component.html',
})
export class SubscriptionComponent implements OnInit {

  subscription: SubscriptionInfo;
  loading: boolean;
  userRole: UserRole;
  showChangePlanDialog: boolean;
  showSubscribeDialog: boolean;
  redirectedFromPayment: boolean;

  protected readonly UserRole = UserRole;

  constructor(
    private paymentService: PaymentService,
    private authService: AuthService,
    private dialogService: DialogService,
    private loaderService: LoaderService,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
  ) {
  }

  ngOnInit() {
    this.getSubscriptionInfo();
  }

  getSubscriptionInfo() {
    this.loading = true;
    this.userRole = this.authService.getUserDataValue()?.authorities[0] as UserRole;
    this.redirectedFromPayment = !!this.activatedRoute.snapshot.queryParams['payment'];
    this.paymentService.getSubscriptionInfo()
      .pipe(finalize(() => this.loading = false))
      .subscribe((value) => {
        this.subscription = value;
      });
  }


  toggleSubscribeDialog() {
    this.showSubscribeDialog = !this.showSubscribeDialog;
  }

  subscribe(role: UserRole) {
    this.toggleSubscribeDialog();
    const user = this.authService.getUserDataValue() as BasicUserData;
    window.location.href = this.paymentService.getSubscriptionStripeUrl(
      role === UserRole.ROLE_BUSINESS ? PaymentType.BusinessSubscription : PaymentType.BusinessPlusSubscription,
      user?.userId,
      user?.email);
  }

  toggleChangePlanDialog() {
    this.showChangePlanDialog = !this.showChangePlanDialog;
  }

  changePlan(role: UserRole) {
    this.toggleChangePlanDialog();
    this.loaderService.showLoader();
    this.paymentService.updateSubscription(role)
      .pipe(finalize(() => this.loaderService.hideLoader()))
      .subscribe((response) => {
        if (response.status === SimpleStatus.SUCCESS) {
          /**
           * t(user.subscription.subscription_updated)
           */
          this.toastService.showSuccessToast('user.subscription.subscription_updated');
          window.location.reload();
        }
        if (response.status === SimpleStatus.FAILED) {

          /**
           * t(user.subscription.subscription_update_failed)
           */
          this.toastService.showErrorToast('user.subscription.subscription_update_failed');
        }
      });
  }

  cancelSub() {
    this.dialogService.openConfirmDialog(() => {
      this.loaderService.showLoader();
      this.paymentService.cancelSubscription()
        .pipe(finalize(() => this.loaderService.hideLoader()))
        .subscribe(() => {
          /**
           * t(user.subscription.subscription_canceled)
           */
          this.toastService.showSuccessToast('user.subscription.subscription_canceled');
          window.location.reload();
        });
    });
  }
}
